// Dummy data and presets for Voucher Entry module in Transactions

export const VOUCHER_TYPES = [
  { id: "payment", code: "F5", name: "Payment", prefix: "PV", key: "F5", color: "#d97706" },
  { id: "receipt", code: "F6", name: "Receipt", prefix: "RV", key: "F6", color: "#2563eb" },
  { id: "journal", code: "F7", name: "Journal", prefix: "JV", key: "F7", color: "#064e48" },
  { id: "contra", code: "F4", name: "Contra", prefix: "CV", key: "F4", color: "#475569" },
  { id: "purchase", code: "F9", name: "Purchase", prefix: "PU", key: "F9", color: "#0d9488" },
  { id: "debit_note", code: "F1", name: "Debit Note", prefix: "DN", key: "F1", color: "#9333ea" },
  { id: "credit_note", code: "F2", name: "Credit Note", prefix: "CN", key: "F2", color: "#e11d48" },
];

const SHORTCUT_MAP = {
  payment: "F5",
  receipt: "F6",
  journal: "F7",
  contra: "F4",
  purchase: "F9",
  "debit note": "F1",
  debit_note: "F1",
  "credit note": "F2",
  credit_note: "F2",
};

export const isSalesType = (item) => {
  if (!item) return false;
  const name = String(item.VTypeName || item.name || item.id || "").toLowerCase().trim();
  const vtype = Number(item.VType || item.vtype);
  return name === "sales" || name === "sale" || vtype === 5;
};

export const normalizeVoucherType = (item) => {
  const name = item.VTypeName || item.name || "";
  const normalizedKey = name.toLowerCase().trim().replace(/[\s-]+/g, "_");
  const rawId = item.id || normalizedKey;
  const vtype = item.VType || item.vtype;
  const prefix = item.Prefix || item.prefix || (name.slice(0, 2).toUpperCase() + "V");
  const code = item.code || item.key || SHORTCUT_MAP[name.toLowerCase().trim()] || SHORTCUT_MAP[normalizedKey] || "";

  return {
    id: rawId,
    vtype,
    name,
    prefix,
    code,
    key: code,
    color: item.color || "#064e48",
  };
};

export const DUMMY_LEDGERS = [
  { id: "L001", name: "Depreciation A/c", group: "Indirect Expenses", groupCode: 18, balance: "1,20,000.00 Dr" },
  { id: "L002", name: "Accumulated Depreciation A/c", group: "Fixed Assets (Contra)", groupCode: 10, balance: "3,80,000.00 Cr" },
  { id: "L003", name: "Cash in Hand", group: "Cash-in-hand", groupCode: 16, balance: "45,200.00 Dr" },
  { id: "L004", name: "HDFC Bank Current A/c", group: "Bank Accounts", groupCode: 24, balance: "8,92,450.00 Dr" },
  { id: "L005", name: "State Bank of India (SBI)", group: "Bank Accounts", groupCode: 24, balance: "3,15,800.00 Dr" },
  { id: "L006", name: "Office Rent A/c", group: "Indirect Expenses", groupCode: 18, balance: "85,000.00 Dr" },
  { id: "L007", name: "Electricity & Utility Expenses", group: "Indirect Expenses", groupCode: 18, balance: "18,450.00 Dr" },
  { id: "L008", name: "Staff Salary A/c", group: "Indirect Expenses", groupCode: 18, balance: "4,60,000.00 Dr" },
  { id: "L009", name: "ABC Tours & Travels Pvt Ltd", group: "Sundry Debtors", groupCode: 33, balance: "2,40,000.00 Dr" },
  { id: "L010", name: "Global India Corp", group: "Sundry Debtors", groupCode: 33, balance: "1,15,000.00 Dr" },
  { id: "L011", name: "Royal Fleets & Logistics", group: "Sundry Creditors", groupCode: 23, balance: "3,50,000.00 Cr" },
  { id: "L012", name: "Bharat Petroleum Fuel Station", group: "Sundry Creditors", groupCode: 23, balance: "94,300.00 Cr" },
  { id: "L013", name: "GST Output CGST 9%", group: "Duties & Taxes", groupCode: 9, balance: "52,400.00 Cr" },
  { id: "L014", name: "GST Output SGST 9%", group: "Duties & Taxes", groupCode: 9, balance: "52,400.00 Cr" },
  { id: "L015", name: "GST Output IGST 18%", group: "Duties & Taxes", groupCode: 9, balance: "1,12,000.00 Cr" },
  { id: "L016", name: "GST Input CGST 9%", group: "Duties & Taxes", groupCode: 9, balance: "38,200.00 Dr" },
  { id: "L017", name: "GST Input SGST 9%", group: "Duties & Taxes", groupCode: 9, balance: "38,200.00 Dr" },
  { id: "L018", name: "Vehicle Maintenance & Repairs", group: "Direct Expenses", groupCode: 14, balance: "78,500.00 Dr" },
  { id: "L019", name: "Tour Package Booking Revenue", group: "Direct Income", groupCode: 13, balance: "14,80,000.00 Cr" },
  { id: "L020", name: "Capital Account - Kunwar Man Singh", group: "Capital Account", groupCode: 1, balance: "25,00,000.00 Cr" },
];

// Initial state matching image 1 & image 2 (3 fields in header row: Voucher No, Reference No, Voucher Date)
export const INITIAL_VOUCHER_STATE = {
  voucherType: "payment",
  voucherNo: "1",
  referenceNo: "",
  voucherDate: new Date().toISOString().slice(0, 10),
  narration: "",
  rows: [
    { id: 1, type: "Dr", headCode: null, ledger: "", dr: "", cr: "" },
    { id: 2, type: "Dr", headCode: null, ledger: "", dr: "", cr: "" },
    { id: 3, type: "Dr", headCode: null, ledger: "", dr: "", cr: "" },
    { id: 4, type: "Dr", headCode: null, ledger: "", dr: "", cr: "" },
    { id: 5, type: "Dr", headCode: null, ledger: "", dr: "", cr: "" },
  ],
};

// Preset sample vouchers to make the system 100% workable and easy to test
export const SAMPLE_VOUCHERS = [
  {
    id: "v-001",
    voucherType: "journal",
    voucherNo: "JV-007",
    referenceNo: "REF-1023",
    voucherDate: "2026-08-31",
    narration: "Provision for depreciation for August 2026",
    rows: [
      { id: 1, ledger: "Depreciation A/c", dr: "50000.00", cr: "" },
      { id: 2, ledger: "Accumulated Depreciation A/c", dr: "", cr: "50000.00" },
    ],
    totalAmount: 50000,
    createdAt: "2026-08-31T11:30:00",
  },
  {
    id: "v-002",
    voucherType: "payment",
    voucherNo: "PV-042",
    referenceNo: "BILL/2026/89",
    voucherDate: "2026-08-30",
    narration: "Payment made towards fleet maintenance via HDFC Bank",
    rows: [
      { id: 1, ledger: "Vehicle Maintenance & Repairs", dr: "24500.00", cr: "" },
      { id: 2, ledger: "HDFC Bank Current A/c", dr: "", cr: "24500.00" },
    ],
    totalAmount: 24500,
    createdAt: "2026-08-30T14:15:00",
  },
  {
    id: "v-003",
    voucherType: "receipt",
    voucherNo: "RV-108",
    referenceNo: "TR-89211",
    voucherDate: "2026-08-29",
    narration: "Received advance tour booking fee from ABC Tours & Travels",
    rows: [
      { id: 1, ledger: "State Bank of India (SBI)", dr: "75000.00", cr: "" },
      { id: 2, ledger: "ABC Tours & Travels Pvt Ltd", dr: "", cr: "75000.00" },
    ],
    totalAmount: 75000,
    createdAt: "2026-08-29T10:00:00",
  },
  {
    id: "v-004",
    voucherType: "sales",
    voucherNo: "SV-025",
    referenceNo: "INV-2026-091",
    voucherDate: "2026-08-28",
    narration: "Corporate tour package billing with CGST and SGST",
    rows: [
      { id: 1, ledger: "Global India Corp", dr: "118000.00", cr: "" },
      { id: 2, ledger: "Tour Package Booking Revenue", dr: "", cr: "100000.00" },
      { id: 3, ledger: "GST Output CGST 9%", dr: "", cr: "9000.00" },
      { id: 4, ledger: "GST Output SGST 9%", dr: "", cr: "9000.00" },
    ],
    totalAmount: 118000,
    createdAt: "2026-08-28T16:45:00",
  },
];
